import { MESES_CXC, type ReporteCxc } from '@leadsphere/types';

import { CheckboxDropdown } from '../../components/ui/CheckboxDropdown.js';

export interface FiltrosUI {
  anios: string[];
  meses: string[];
  clientes: string[];
  iva: boolean;
  adicionales: boolean;   // #75: "Incluir adicionales" (refacturación, comisiones…)
}

interface Props {
  valor: FiltrosUI;
  opciones: ReporteCxc['opciones'];
  onChange: (f: FiltrosUI) => void;
}

export function FiltrosReportes({ valor, opciones, onChange }: Props) {
  return (
    <div className="filters-bar reportes-filtros">
      <div className="reportes-filtro">
        <CheckboxDropdown
          options={opciones.anios.map(a => ({ value: String(a), label: String(a) }))}
          selected={valor.anios}
          onChange={anios => onChange({ ...valor, anios })}
          placeholder="Año"
        />
      </div>
      <div className="reportes-filtro">
        <CheckboxDropdown
          options={MESES_CXC.map(m => ({ value: m, label: m }))}
          selected={valor.meses}
          onChange={meses => onChange({ ...valor, meses })}
          placeholder="Meses"
        />
      </div>
      <div className="reportes-filtro reportes-filtro-cliente">
        <CheckboxDropdown
          options={opciones.clientes.map(c => ({ value: c.id, label: c.nombre }))}
          selected={valor.clientes}
          onChange={clientes => onChange({ ...valor, clientes })}
          placeholder="Todos los clientes"
        />
      </div>
      <label className="reportes-iva">
        <input type="checkbox" checked={valor.iva} onChange={e => onChange({ ...valor, iva: e.target.checked })} />
        Incluir IVA
      </label>
      <label className="reportes-iva" title="Refacturación de Ads, comisiones y otros cobros que no son tarifa de servicio">
        <input type="checkbox" checked={valor.adicionales} onChange={e => onChange({ ...valor, adicionales: e.target.checked })} />
        Incluir adicionales
      </label>
    </div>
  );
}
